import { GetServerSideProps, GetStaticPropsContext } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import BlogPage from 'presentations/views/components/pages/BlogPage';
import { apiPath, newsPath, webPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { BlogItem, BlogListItem } from 'presentations/api/schema/contents';
import { formatHeadDescription } from 'presentations/views/helpers/formatter';
import Header from 'presentations/views/components/organisms/Header';
import { useContext } from 'react';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import BlogListSidebar from 'presentations/views/components/organisms/BlogListSidebar';

interface ServerProps {
  blog: BlogItem;
  linkCanonical: string;
}

// export async function getStaticPaths({ locales }: { locales: string[] }) {
//   const paths: Object[] = [];
//   const result = await get(
//     apiPath(`/v1/contents/blogs`, {
//       page: 1,
//       perPage: 200,
//     }),
//   );
//   if (!result.isSuccess) {
//     throw result.errorMessage;
//   }
//   if (!result.data) {
//     return 'no result data';
//   }
//   const blogs: BlogListItem[] = result.data;
//   for (const blog of blogs) {
//     for (const locale of locales) {
//       paths.push({
//         params: {
//           blogId: blog.slug,
//         },
//         locale,
//       });
//     }
//   }
//   return {
//     paths,
//     fallback: false,
//   };
// }

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
}: any) => {
  // export async function getStaticProps({
  //   locale,
  //   params,
  // }: GetStaticPropsContext) {
  if (!params) return { notFound: true };
  const blogId = String(params.blogId);

  const result = await get(
    apiPath(`/v1/contents/blogs/${blogId}`, {
      locale,
    }),
  );
  if (!result.isSuccess) {
    return { notFound: true };
  }
  if (!result.data) {
    return { notFound: true };
  }

  const blog: BlogItem = result.data;
  const props: ServerProps = {
    blog,
    linkCanonical: webPath(newsPath(blogId), locale),
  };
  return {
    props,
    // revalidate: 60 * 120
  };
};

export default function Page(props: ServerProps) {
  const { state: serviceState } = useContext(ServicePortalContext);
  const description = formatHeadDescription(props.blog.body);
  return (
    <MainDocument
      title={props.blog.title}
      image={props.blog.ogImageUrl}
      url={props.linkCanonical}
      description={description}
      linkCanonical={props.linkCanonical}
      isShowDownloadLink
      isNoIndex={props.blog.isUnlisted}
    >
      <BlogPage
        blog={props.blog}
        populars={[]}
        header={<Header viewer={serviceState.viewer} />}
        siderbar={<BlogListSidebar />}
      />
    </MainDocument>
  );
}
